export const WORK_AREA_PADDING = { base: "4", md: "6", lg: "8" };

export const WORK_AREA_BLEED = {
  m: { base: "-4", md: "-6", lg: "-8" },
  h: { base: "calc(100% + 2rem)", md: "calc(100% + 3rem)", lg: "calc(100% + 4rem)" },
};
